import React, { Component } from 'react';
import Modal from 'react-modal';
import { connectModal } from 'redux-modal';
import { SHARE_DIALOG } from '../../../constants';
import translate from '../../TranslateHOC';
import ProgrammeActionsShare from '../../ProgrammeActionsShare';
import { programmeTitle } from '../../../helpers';
import { Button as ButtonV2 } from '../../../v2/components/button/Button';

class ShareDialog extends Component {
  constructor() {
    super();

    this.handleCancel = this.handleCancel.bind(this);
  }

  handleCancel() {
    this.props.handleHide();
    if (this.props.handleClose) {
      this.props.handleClose();
    }
  }

  render() {
    const { show, strings, prog } = this.props;
    const trans = strings;
    const progTitles = programmeTitle(
      prog.series_title,
      prog.programme_title,
      prog.clic_aired
    );

    return (
      <Modal
        isOpen={show}
        overlayClassName="dialog__overlay"
        className="dialog__content"
        onRequestClose={this.handleCancel}
        role="dialog"
        ariaHideApp={true}
        contentLabel={trans.adBlockerDetected}
      >
        <div className="dialog--ad-block">
          <div className="dialog__title">
            {trans.share} {progTitles.title}
          </div>
          <div className="dialog__message">
            <p>{trans.whereShare}</p>
          </div>
          <ProgrammeActionsShare prog={prog} strings={strings} />
          <div className="dialog__action-row">
            <ButtonV2
              onClick={this.handleCancel}
              label={trans.cancel}
              size="small"
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default translate(
  connectModal({ name: SHARE_DIALOG, destroyOnHide: true })(ShareDialog)
);
